<template>
    <div class="layout__padding-clear layout__width-100">

         <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">
            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__invoices">
                    <p class="layout__margin__bottom-10">Freetext Search</p>
                    <el-form-item prop="orderFreeText">
                        <el-input placeholder="Search" v-model="searchParams.orderFreeText"
                                  clearable
                                  autofocus></el-input>
                    </el-form-item>
                </div>
                <div class="layout__search-field__invoices">
                    <p class="layout__margin__bottom-10">Invoice Type</p>
                    <el-form ref="products">
                        <el-form-item prop="orderSource">
                            <el-select v-model="searchParams.type" placeholder="Invoice Type" clearable>
                                <el-option v-for="type in ravensworth.billStatus.options"
                                           :key="type.id"
                                           :label="type.text"
                                           :value="type.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__invoices">
                    <p class="layout__margin__bottom-10">Bill Status</p>
                    <el-form ref="status">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.billStatus" placeholder="Order Status" clearable>
                                <el-option v-for="status in ravensworth.invoiceStatus.options"
                                           :key="status.id"
                                           :label="status.text"
                                           :value="status.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="layout__search-field__invoices">
                    <p class="layout__margin__bottom-10">To - From Date</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                                v-model="searchParams.salesDateRange"
                                type="daterange"
                                range-separator="To"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </div>
            </div>

        </el-form>
        <div class="layout__display-block layout__width-100">
            <el-button class="button-red layout__position-center button__base layout__width-150px" id="getInvoices" v-on:click="getOrders('searchParams')">Search Orders
            </el-button>
        </div>

        <el-button class="layout__display-none" id="getInvoicesPagination" v-on:click="getPaginatedResults()">Search Orders
        </el-button>

        <el-button :disabled="false" class="button-teal layout__position-right button__base__admin layout__width-200px"
                   id="downloadAllResults" v-on:click="downloadAllResults()" :loading="downloadLoading">Download Data (csv)
        </el-button>

        <div class=" layout__position-right layout__padding-5-10">
            <p>{{this.resultsCount}} Results Found</p>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import moment from 'moment';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';

    export default {
        name: "adminOrdersSearch",
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            searchParams: Object,
            invoices: Array,
            loading: Boolean,
            resultsCount: String
        },
        data() {
            return {
                jobStatus: '',
                downloadLoading: false,
                queryRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/invoiceSearchadmin?`,
                parameters: [],
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                queryOptions: [],
                freetextQueryOptions: [],
                resourcePath: '/odata/InvoiceSearch?$filter=',
                queryConcatAnd: '+and+',
                queryConcatOr: '+or+',
                exportDate: new Date().toLocaleTimeString('en-GB') + '_invoices.csv',
                finalQuery: '',
                territories: [],
                users: [],
                pickerOptions: {
                    shortcuts: [{
                        text: 'Last week',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', start);
                        }
                    }, {
                        text: 'Last month',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            console.log(start.toLocaleDateString('en-GB'))
                            picker.$emit('pick', start);
                        }
                    }, {
                        text: 'Last 3 months',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', start);
                        }
                    }]
                },
                rules: {
                    salesDateRange: [{
                        required: true,
                        message: 'To/From Dates required',
                        trigger: 'blur'
                    }]
                }
            }
        },
        created() {
            this.isUserAuthorised();

            this.$parent.searchParams.salesDateRange[0] = moment().startOf('month').format('YYYY-MM-DD')
            this.$parent.searchParams.salesDateRange[1] = moment().endOf('month').format('YYYY-MM-DD')

            if (window.sessionStorage.getItem('_adminInvoiceSearch') !== null && typeof window.sessionStorage.getItem('_adminInvoiceSearch') !== 'undefined') {
                this.$parent.searchParams = JSON.parse(window.sessionStorage.getItem('_adminInvoiceSearch'))
            }

            this.getResults()

            // todo the search works orders pages spec out initial search criteria and pass into here with orders array and the parent gets updated with the results
        },
        beforeUpdate() {
            console.log('UPDATING ADMIN ORDERS SEARCH')
            console.log(this.$parent.searchParams)
            window.sessionStorage.setItem('_adminInvoiceSearch', JSON.stringify(this.$parent.searchParams));
        },

        methods: {
            constructQueryString() {
                this.parameters = []
                let searchTerms = Object.assign({}, this.$parent.searchParams)

                if(searchTerms.orderFreeText !== '') {
                    this.parameters.push('freetext=' + searchTerms.orderFreeText)
                }

                this.parameters.push('startDate=' + searchTerms.salesDateRange[0])
                this.parameters.push('endDate=' + moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD'))

                if (searchTerms.billStatus !== null && searchTerms.billStatus !== '' && searchTerms.billStatus !== 'ANY STATUS') {
                    this.parameters.push('status=' + searchTerms.billStatus)
                }

                if (searchTerms.type !== '' && searchTerms.type !== 'ANY TYPE') {
                    this.parameters.push('type=' + searchTerms.type)
                }


            },

            // constructQueryString_old() {
            //
            //     this.queryOptions = []
            //     this.freetextQueryOptions = []
            //
            //     let searchTerms = Object.assign({}, this.$parent.searchParams)
            //
            //     let baseQueryUri = this.serviceRouteUrl + this.resourcePath
            //
            //     // this.finalQuery = ''
            //
            //     if (searchTerms.orderFreeText !== '') {
            //         this.freetextQueryOptions.push('contains(Code, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(Branch, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(Name, \'' + searchTerms.orderFreeText + '\')')
            //         this.freetextQueryOptions.push('contains(LedgerBranch, \'' + searchTerms.orderFreeText + '\')')
            //     }
            //
            //     // todo need to add territory in the freetext search and the assigned to
            //
            //     this.queryOptions.push('created+gt+' + searchTerms.salesDateRange[0] + 'T00:00:00.000Z')
            //
            //     // if (searchTerms.salesDateRange[0] === searchTerms.salesDateRange[1]) {
            //     //     searchTerms.salesDateRange[1] = moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
            //         this.queryOptions.push('created+lt+' + moment(searchTerms.salesDateRange[1], 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD') + 'T00:00:00.000Z')
            //     // } else {
            //     //     this.queryOptions.push('created+lt+' + searchTerms.salesDateRange[1] + 'T00:00:00.000Z')
            //     // }
            //
            //     if (searchTerms.billStatus !== null && searchTerms.billStatus !== '' && searchTerms.billStatus !== 'ANY STATUS') {
            //         this.queryOptions.push('Status+eq+\'' + searchTerms.billStatus + '\'')
            //     }
            //
            //     if (searchTerms.type !== '' && searchTerms.type !== 'ANY TYPE') {
            //         this.queryOptions.push('Type+eq+\'' + searchTerms.type + '\'')
            //     }
            //
            //     if (searchTerms.orderFreeText !== '') {
            //         this.finalQuery = baseQueryUri.concat('(' + this.freetextQueryOptions.join(this.queryConcatOr) + ')', this.queryConcatAnd, this.queryOptions.join(this.queryConcatAnd))
            //     } else {
            //         this.finalQuery = baseQueryUri.concat(this.queryOptions.join(this.queryConcatAnd))
            //     }
            //
            // },
            getResults() {

                this.constructQueryString()

                let getResults = this.queryRouteUrl + this.parameters.join('&') + '&skip=' + this.searchParams.skip + '&top=' + this.searchParams.top
                console.log('results')
                console.log(getResults)

                this.$parent.loading = true
                Axios.get(getResults, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$parent.invoices = response.data.value

                        console.log(this.$parent.invoices.length)

                        for (let i = 0; i < this.$parent.invoices.length; i++) {
                            this.$parent.invoices[i].created = this.$parent.invoices[i].created.split("T")[0]
                        }
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        // this.orders[0].id = 'updated from search'
                        this.$parent.invoices = []
                        // }
                    })

                let getCounts = '';
                getCounts = this.queryRouteUrl + this.parameters.join('&') + '&count=true&top=0'
                console.log('count')
                console.log(getCounts)

                Axios.get(getCounts, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data)
                        console.log(response.data['@odata.count'])
                        this.$parent.resultsCount = response.data['@odata.count']
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                    })

            },
            getTopResults() {
                //    todo this method will return getResults without the form validation - might be able to get rid of this
                this.getResults()
            },
            downloadAllResults() {

                this.downloadLoading = true

                this.constructQueryString()
                console.log(this.finalQuery)
                Axios.get(this.finalQuery, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data.value.length)

                        let fields = [];

                        if (JSON.parse(this.returnCookie('_role')).includes('RpsBilling')) {
                            fields = [
                                {label: 'Id', value: 'id'},
                                {label: 'Code', value: 'code'},
                                {label: 'Type', value: 'type'},
                                {label: 'Status', value: 'status'},
                                {label: 'Created', value: 'created'},
                                {label: 'Order_No', value: 'orderNo'},
                                {label: 'Branch', value: 'branch'},
                                {label: 'Name', value: 'name'},
                                {label: 'No_Jobs', value: 'noJobs'},
                                {label: 'Net_Total', value: 'netTotal'},
                                {label: 'SL_Branch', value: 'ledgerBranch'},
                                {label: 'SL_Status', value: 'ledgerStatus'}
                            ];
                        } else {
                            fields = [
                                {label: 'Id', value: 'id'},
                                {label: 'Code', value: 'code'},
                                {label: 'Type', value: 'type'},
                                {label: 'Status', value: 'status'},
                                {label: 'Created', value: 'created'},
                                {label: 'Order_No', value: 'orderNo'},
                                {label: 'Branch', value: 'branch'},
                                {label: 'Name', value: 'name'},
                                {label: 'Head_Office', value: 'ledgerBranch'},
                                {label: 'No_Jobs', value: 'noJobs'},
                                {label: 'Net_Total', value: 'netTotal'}
                            ];
                        }

                        this.downloadCsv(this.exportDate, fields, response.data.value)
                        this.downloadLoading = false
                    })
                    .catch(error => {

                    })



            },
            getOrders(searchParams) {


                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.$parent.searchParams.skip = 0;
                        this.$parent.searchParams.currentPage = 1;
                        this.getResults()
                    } else {
                        return false;
                    }
                })
            },
            getPaginatedResults() {
                //    todo this method will return getResults without the form validation - might be able to get rid of this
                this.getResults()
            },
        }
    };
</script>